<template>
    <div class="xtxx">
        <div class="content">

            <!-- 筛选区域 -->
            <div class="search" style="margin-top:10px">
                <div class="filter-dropdown">
                    <button class="filterbt" @click.stop="showFilter = !showFilter">
                        {{ filterText }} ▼
                    </button>
                    <div class="filter-options" :class="{ show: showFilter }">
                        <div class="filter-option" @click="setFilter('all')">全部</div>
                        <div class="filter-option" @click="setFilter('pending')">待开票</div>
                        <div class="filter-option" @click="setFilter('invoiced')">已开票</div>
                    </div>
                </div>
                <button v-if="invoiceEnabled" class="searchbt" @click="batchInvoice">批量开票</button>
            </div>

            <!-- 费用列表 -->
            <div class="pj" v-for="(item, index) in filteredList" :key="index">
                <div class="xq">
                    <span>{{ item.typeName }}</span>
                    <span>{{ houseName }}</span>
                    <button class="dpj">已缴</button>
                    <button
                        v-if="item.type === '1' && invoiceEnabled"
                        class="dpj1"
                        :class="invoiceBtnClass(item)"
                        @click="onInvoiceClick(item)"
                    >
                        {{ invoiceBtnText(item) }}
                    </button>
                </div>
            </div>

            <div class="load-more" v-if="list.length > 0">
                <span>没有更多了</span>
            </div>
            <div class="load-more" v-else-if="loaded">
                <span>暂无数据</span>
            </div>

        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {
            list: [],
            houseName: '',
            showFilter: false,
            currentFilter: 'all',
            filterText: '筛选',
            loaded: false,
            invoiceEnabled: false,
        }
    },
    computed: {
        ...mapState(['userInfo', 'identity', 'houseId']),
        filteredList() {
            if (this.currentFilter === 'all') return this.list;
            if (this.currentFilter === 'pending') return this.list.filter(item => !item.isInvoiced);
            if (this.currentFilter === 'invoiced') return this.list.filter(item => item.isInvoiced);
            return this.list;
        }
    },
    mounted() {
        this.houseName = sessionStorage.getItem('houseName');
        this.getData();
        document.addEventListener('click', this.closeFilter);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeFilter);
    },
    methods: {
        getData() {
            this.$axios.get('/api/v1/wygl/propertyPayment/viewListById?id=' + this.$route.query.id).then(res => {
                if (res) {
                    this.list = res || [];
                    // 同一账单下所有费用项都属于同一小区，取第一条即可
                    this.invoiceEnabled = (this.list[0] && this.list[0].invoiceEnabled) || false;
                }
                this.loaded = true;
            });
        },
        setFilter(filter) {
            this.currentFilter = filter;
            const filterMap = { all: '筛选', pending: '待开票', invoiced: '已开票' };
            this.filterText = filterMap[filter];
            this.showFilter = false;
        },
        closeFilter(e) {
            if (!e.target.closest('.filter-dropdown')) {
                this.showFilter = false;
            }
        },
        batchInvoice() {
            const pendingItems = this.filteredList.filter(item => item.type === '1' && (!item.orderStatus || item.orderStatus === '3' || item.fpzt === '1' || item.fpzt === '2'));
            if (pendingItems.length === 0) {
                this.$toast('没有待开票的项目');
                return;
            }
            // 批量开票：逐条跳转开票页面，先跳第一条
            var first = pendingItems[0];
            this.$router.push({
                path: '/wyfw/invoicefill',
                query: {
                    id: first.id,
                    typeName: first.typeName,
                    amount: first.actually,
                    villageId: first.villageId || '',
                    type: first.type || '',
                    villageName: first.villageName || '',
                    ownerName: first.owoner || '',
                    time: first.time || ''
                }
            });
        },
        invoiceBtnText(item) {
            var s = item.orderStatus;
            var fpzt = item.fpzt;
            // isInvoiced为true但orderStatus为空，说明已开票成功
            if (!s && item.isInvoiced) return '查看发票';
            if (!s) return '开具发票';
            if (s === '1') return '开具中...';
            if (s === '3') return '重新开具';
            if (s === '2') {
                if (fpzt === '1' || fpzt === '2') return '重新开票';
                if (fpzt === '10') return '红冲中...';
                return '查看发票';
            }
            return '开具发票';
        },
        invoiceBtnClass(item) {
            var s = item.orderStatus;
            var fpzt = item.fpzt;
            if (!s && item.isInvoiced) return 'btn-view-invoice';
            if (!s) return 'btn-apply-invoice';
            if (s === '1') return 'btn-processing';
            if (s === '3') return 'btn-apply-invoice';
            if (s === '2') {
                if (fpzt === '1' || fpzt === '2') return 'btn-apply-invoice';
                if (fpzt === '10') return 'btn-processing';
                return 'btn-view-invoice';
            }
            return 'btn-apply-invoice';
        },
        onInvoiceClick(item) {
            var s = item.orderStatus;
            var fpzt = item.fpzt;
            // 已开票（isInvoiced为true但orderStatus为空）→ 查看发票详情
            if (!s && item.isInvoiced) {
                this.$router.push({
                    path: '/wyfw/invoicedetail',
                    query: { xsdjbh: item.xsdjbh || '' }
                });
                return;
            }
            if (s === '2' && fpzt !== '1' && fpzt !== '2' && fpzt !== '10') {
                // 正常已开票 - 查看发票
                this.$router.push({
                    path: '/wyfw/invoicedetail',
                    query: { xsdjbh: item.xsdjbh || '' }
                });
            } else if (s === '2' && fpzt === '10') {
                // 红冲中 - 不操作
                return;
            } else if (s === '1') {
                // 开具中 - 查看详情
                this.$router.push({
                    path: '/wyfw/invoicedetail',
                    query: { xsdjbh: item.xsdjbh || '' }
                });
            } else {
                // 未开票 / 失败 / 已红冲/已作废 - 去开票
                this.$router.push({
                    path: '/wyfw/invoicefill',
                    query: {
                        id: item.id,
                        typeName: item.typeName,
                        amount: item.actually,
                        villageId: item.villageId || '',
                        type: item.type || '',
                        villageName: item.villageName || '',
                        ownerName: item.owoner || '',
                        time: item.time || ''
                    }
                });
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .content{
        height: 100%;
        width: 92%;
        margin: 0 4% 0 4%;
    }
    .xtxx{
        height: calc(100% - 50px);
        width: 100%;
        display: flex;
        background-color: #fff;
        flex-direction: column;
        align-items: center;
        overflow-y: auto;
        .pj{
            display: flex;
            width: 94%;
            padding:14px 10px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            box-shadow: 0px 0px 5px #e6e6e6;
            margin-top: 10px;
            .xq{
                height: 100%;
                min-height: 80px;
                width: 100%;
                margin-left: 2%;
                display: flex;
                flex-direction: column;
                position: relative;
                span{
                    width:70%;
                }
                span:nth-child(1){
                    font-weight: bold;
                }
                span:nth-child(2){
                    margin-top: 5px;
                    color: #999999;
                }
                .dpj{
                    height: 25px;
                    top: 0;
                    position: absolute;
                    right: 2%;
                    border: 1px solid #00d2ff;
                    color: #00d2ff;
                    background-color: transparent;
                    border-radius: 30px;
                    font-size: 15px;
                }
                .dpj1{
                    height: 25px;
                    bottom: 0;
                    position: absolute;
                    right: 2%;
                    background-color: transparent;
                    border-radius: 30px;
                    font-size: 15px;
                }
                .btn-view-invoice{
                    border: 1px solid #00b5ff;
                    color: #00b5ff;
                }
                .btn-apply-invoice{
                    border: 1px solid #ff4444;
                    color: #ff4444;
                }
                .btn-processing{
                    border: 1px solid #ccc;
                    color: #ccc;
                    pointer-events: none;
                }
            }
        }
        .search{
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 13px;
            text-align: center;
            .filter-dropdown{
                position: relative;
                .filterbt{
                    height: 30px;
                    width: 80px;
                    background: #fff;
                    border-radius: 10px;
                    border: 1px solid #ddd;
                    outline: none;
                    color: #666;
                    font-size: 13px;
                }
                .filter-options{
                    display: none;
                    position: absolute;
                    top: 100%;
                    left: 0;
                    margin-top: 5px;
                    background-color: #fff;
                    border: 1px solid #ddd;
                    border-radius: 8px;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                    z-index: 100;
                    min-width: 100px;
                    &.show{
                        display: block;
                    }
                    .filter-option{
                        padding: 10px 15px;
                        font-size: 13px;
                        color: #333;
                        &:active{
                            background-color: #f5f5f5;
                        }
                    }
                }
            }
        }
        .searchbt{
            height: 30px;
            width: 100px;
            background: #00b5ff;
            border-radius: 10px;
            border: none;
            outline: none;
            color: #fff;
        }
        .load-more{
            text-align: center;
            padding: 20px 0;
            color: #999;
            font-size: 14px;
        }
        ::-webkit-scrollbar{
            display: none;
        }
    }
</style>
